import React, { useState, createContext } from "react";

const ApiErrorContext = createContext({
  error: 0,
  message: "",
  setErrorCode: statusCode => {},
  setErrorMessage: msg => {}
});

export const ApiErrorProvider = props => {
  const [error, setError] = useState(0);
  const [message, setMessage] = useState("");

  const setErrorCode = statusCode => {
    setError(statusCode);
  };

  const setErrorMessage = msg => {
    setMessage(msg);
  };

  return (
    <ApiErrorContext.Provider value={{ error, message, setErrorCode, setErrorMessage }}>
      {props.children}
    </ApiErrorContext.Provider>
  );
};

export const useApiError = () => {
  const context = React.useContext(ApiErrorContext);
  return context;
};
